var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Player from "./Player";
import Algorithms from "@/lib/BotSDK/algorithms";
import BotController from "@/lib/BotSDK";
var Enemy = /** @class */ (function (_super) {
    __extends(Enemy, _super);
    function Enemy(scene, data) {
        var _this = _super.call(this, scene, data) || this;
        _this.controller = new BotController(_this, __spreadArray([_this.scene.player], _this.scene.enemies, true), Algorithms);
        return _this;
    }
    Enemy.prototype.update = function () {
        this.move();
        this.controller.update();
    };
    Enemy.prototype.death = function (callback) {
        _super.prototype.death.call(this, callback);
        this.controller.release();
    };
    return Enemy;
}(Player));
export default Enemy;
